import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompaniesRescuenetComponent } from './companies-rescuenet.component';


const routes: Routes = [{
  path: 'external-companies',
  component: CompaniesRescuenetComponent,
  data: {
    title: 'External Companies'
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CompaniesRescuenetRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/companies-rescuenet/companies-rescuenet-routing.module.ts